import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Chip } from '@mui/material';
import { MouseEvent } from 'react';

export type RibbonToastPrimaryActionProps = {
  label: string;
  onAction: () => void;
  /** When true, shows an open-in-new icon (absolute http(s) destinations). */
  opensInNewTab?: boolean;
};

/**
 * Primary toast CTA as a compact outlined chip (same control as the notification feed).
 */
export function RibbonToastPrimaryAction({
  label,
  onAction,
  opensInNewTab = false,
}: RibbonToastPrimaryActionProps) {
  function handleClick(event: MouseEvent) {
    // Avoid double-firing when the Paper is also clickable (auto-close toasts).
    event.stopPropagation();
    onAction();
  }

  return (
    <Chip
      label={label}
      size="small"
      variant="outlined"
      clickable
      icon={opensInNewTab ? <OpenInNewIcon /> : undefined}
      onClick={handleClick}
      sx={{ alignSelf: 'flex-start' }}
    />
  );
}
